import React, { useEffect, useState, useRef } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./redux/store";
import { actionCreators } from "./redux/actions";
import CoverageAppState from "./interfaces/CoverageAppState";
import TabName from "./interfaces/TabName";
import { CoverageService } from "../../services/coverageService";
import { render } from "../../common/reactUtils";
import Modal from "./components/Modal";
import Tooltip from "./components/Tooltip";
import CategoriesList from "./components/CategoriesList";
import DocumentList from "./components/DocumentList";
import { ParentCategoryExpanded } from "./interfaces/ParentCategoryExpanded";

const CoverageApp = () => {
  const dispatch = useDispatch();
  const coverageService = new CoverageService();
  const updated = useSelector((state: CoverageAppState) => state.updated);
  const visibleTabName = useSelector(
    (state: CoverageAppState) => state.visibleTabName
  );
  const [expandedParentCategories, setExpandedParentCategories] = useState<
    ParentCategoryExpanded[]
  >([]);

  useEffect(() => {
    removeRootNode();

    coverageService.getUpdatedWatchedPages(
      (res) => {
        setAllUpdated(res);
      },
      (res) => console.error(res)
    );

    // Load data
    coverageService.getCoverageCategories(
      (res) => {
        setAllCategories(res);
      },
      (res) => console.error(res)
    );

    coverageService.getCoverages(
      (res) => {
        setAllCoverages(res);
      },
      (res) => console.error(res)
    );
  }, []);

  const [currentNumberOfCategories, setCurrentNumberOfCategories] = React.useState<number>(0);

  const setVisibleTabName = (name: TabName) =>
    dispatch(actionCreators.setVisibleTabName(name));
  const setAllCategories = (categories) =>
    dispatch(actionCreators.setAllCategories(categories));
  const setAllUpdated = (items) => {
    dispatch(actionCreators.setAllUpdated(items));
  };
  const setAllCoverages = (coverages) =>
    dispatch(actionCreators.setAllCoverages(coverages));

  const setCurrentNumberOfCoveredCategories = (number: number) => {
    setCurrentNumberOfCategories(number);
  };

  const renderTab = (name) => {
    switch (name) {
      case TabName.ByCategory:
        return (
          <CategoriesList
            expandedParentCategories={expandedParentCategories}
            setExpandedParentCategories={(newParents) => {
              setExpandedParentCategories(newParents);
            }}
            setNumberOfFollowedCategories={setCurrentNumberOfCoveredCategories}
                onCloseCallback={() => setVisibleTabName(TabName.Updated)}
                visibleTabName={visibleTabName}
          />
        );
      case TabName.Document:
            return <DocumentList/>;
      default:
        return null;
    }
  };

  useEffect(() => {
    const unvisited = updated.filter((item) => !item.visited).length;
    if(unvisited > 0){
      setUnvisitedIndicator(unvisited);
    }
  }, [updated]);

  const setUnvisitedIndicator = (unvisited: number) => {
    const unvisitedIndicator = document.getElementById("unvisited-indicator");
    const userUnvisitedIndicator = document.getElementById("user-unvisited-indicator");
    if (unvisitedIndicator) {
      if(currentNumberOfCategories > 0){
          unvisitedIndicator.innerHTML = unvisited.toString();
          unvisitedIndicator.style.display = "block";
          userUnvisitedIndicator.style.display = "block";
      }
    }
  };

  const removeRootNode = () => {
    const node: any = document.getElementById("js-react-coverage-app");
    node && node.replaceWith(...node.childNodes);
  };

  const examModeContainer = document.getElementById("exam-mode-container");
  let examModeContent: string | null = null;

  if (examModeContainer && !examModeContainer.classList.contains("exam-mode-container_consultant")) {
      examModeContent = examModeContainer.innerHTML;
  }

  return (
    <div
      className="personal__subnavigation  personal__subnavigation--expanded coverageSubmenu"
      id="js-react-coverage-expanded"
    >
      <div className="notifications  notifications--coverage">
        <div
          id="sidebar-coverage"
          className="notifications__list-wrapper  notifications__list-wrapper--flex"
        >

          {examModeContent && (
            <div
                dangerouslySetInnerHTML={{ __html: examModeContent }}
            />
          )}
          {!examModeContent && (
              <>
                  {renderTab(visibleTabName)}
                  <div className="hidden">
                    <CategoriesList
                      expandedParentCategories={expandedParentCategories}
                      setExpandedParentCategories={(newParents) => {
                        setExpandedParentCategories(newParents);
                      }}
                      setNumberOfFollowedCategories={setCurrentNumberOfCoveredCategories}
                        onCloseCallback={() => setVisibleTabName(TabName.Updated)}
                        visibleTabName={visibleTabName}
                      />
                  </div>
               </>
             )}
        </div>
      </div>
      <Modal />
      <Tooltip />
    </div>
  );
};

export const initialize = () => {
  render(
    <Provider store={store}>
      <CoverageApp />
    </Provider>,
    "#js-react-coverage-app"
  );
};
